import { Box, Dialog, DialogContent, DialogTitle } from '@material-ui/core'
import React, { useContext, useEffect, useState } from 'react'
import BackspaceIcon from '../../../shared/icons/backspace_icon'
import buildStyles from './styles'
import cx from 'classnames'
import { MOBILE_WIDTH_HIGH } from '../../../constants/constants'
import { useWindowSize } from '../../../hooks/useWindowSize'
import CloseIconCD from '../../../shared/icons/close_icon_CD'
import AppContext from '../../../app/context'

export interface PayAmountNumpadProps {
  isOpen: boolean
  maxWidth?: false | 'xs' | 'sm' | 'md' | 'lg' | 'xl' | undefined
  amount: number | undefined
  setAmount: (value: number) => void
  onClose: () => void
  onConfirm: () => void
}

const PayAmountNumpad = ({
  isOpen,
  maxWidth,
  amount,
  setAmount,
  onClose,
  onConfirm,
}: PayAmountNumpadProps) => {
  const { state } = useContext(AppContext)
  const screen = useWindowSize()
  const isMobile: boolean = (screen.width as number) < MOBILE_WIDTH_HIGH

  const [enable, setEnable] = useState(false)

  const updateAmount = (value: number) => {
    if (value === 0 && amount === undefined) return
    if (value === 0) {
      setAmount((amount ?? 0) * 10)
    } else {
      setAmount((amount ?? 0) * 10 + value)
    }
  }

  const buttonPressed = (value: number) => {
    if ((amount ?? 0).toString().length < 4) updateAmount(value)
  }

  const resetAmount = () => {
    setAmount(0)
  }

  const deleteAmount = () => {
    setAmount(Math.trunc((amount ?? 0) / 10))
  }

  const handleConfirm = () => {
    if (enable) {
      onConfirm()
    }
  }

  useEffect(() => {
    if (amount && 0 < amount && amount <= 9999) {
      setEnable(true)
    } else {
      setEnable(false)
    }
  }, [amount])

  if (!state.locationDesignConfig) return null

  const styles = buildStyles({
    isMobile: isMobile,
    baseColors: state.locationDesignConfig.baseColors,
  })

  return (
    <>
      <Dialog
        fullScreen={false}
        open={isOpen}
        onClose={onClose}
        maxWidth={maxWidth}
        fullWidth
        PaperProps={{ style: { borderRadius: 25 } }}
      >
        <DialogTitle>
          <Box display="flex" justifyContent="space-between">
            <div className={styles.numpadTitle}>Wprowadź swoją kwotę</div>
            <div className={styles.closeNumpad} onClick={onClose}>
              <CloseIconCD />
            </div>
          </Box>
        </DialogTitle>
        <DialogContent>
          <div className={styles.numpad}>
            <div>
              <div className={styles.numberField}>
                <input
                  type="text"
                  pattern="^[0-9\b]+$"
                  autoFocus
                  value={amount !== 0 ? amount : 0}
                  placeholder="0"
                  onChange={(e) => {
                    if (Number(e.target.value) <= 9999) {
                      setAmount(Number(e.target.value))
                    }
                  }}
                  className={styles.numberFieldInput}
                />
                <span className={styles.numberFieldText}>zł</span>
              </div>
            </div>
            <Box className={styles.buttons}>
              <div
                onClick={() => buttonPressed(1)}
                className={cx(styles.button, styles.num1)}
              >
                1
              </div>
              <div
                onClick={() => buttonPressed(2)}
                className={cx(styles.button, styles.num2)}
              >
                2
              </div>
              <div
                onClick={() => buttonPressed(3)}
                className={cx(styles.button, styles.num3)}
              >
                3
              </div>
              <div
                onClick={() => buttonPressed(4)}
                className={cx(styles.button, styles.num47)}
              >
                4
              </div>
              <div
                onClick={() => buttonPressed(5)}
                className={cx(styles.button, styles.num58)}
              >
                5
              </div>
              <div
                onClick={() => buttonPressed(6)}
                className={cx(styles.button, styles.num69)}
              >
                6
              </div>
              <div
                onClick={() => buttonPressed(7)}
                className={cx(styles.button, styles.num47)}
              >
                7
              </div>
              <div
                onClick={() => buttonPressed(8)}
                className={cx(styles.button, styles.num58)}
              >
                8
              </div>
              <div
                onClick={() => buttonPressed(9)}
                className={cx(styles.button, styles.num69)}
              >
                9
              </div>
              <div
                onClick={() => resetAmount()}
                className={cx(styles.button, styles.numReset)}
              >
                RESET
              </div>
              <div
                onClick={() => buttonPressed(0)}
                className={cx(styles.button, styles.num0)}
              >
                0
              </div>
              <div
                onClick={() => deleteAmount()}
                className={cx(styles.button, styles.numBackspace)}
              >
                <BackspaceIcon />
              </div>
            </Box>

            <div
              className={cx(
                styles.confirmButton,
                !enable ? styles.disabledButton : undefined
              )}
              onClick={handleConfirm}
            >
              <span className={styles.confirmButtonSpan}>ZATWIERDŹ</span>
            </div>
          </div>
        </DialogContent>
      </Dialog>
    </>
  )
}

export default PayAmountNumpad
